import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './Races.css';
import { useTokens } from '../components/TokenContext';

const horses = [
    { id: 1, name: 'Zelený (1)', img: 'horse1.png' },
    { id: 2, name: 'Modrý (2)', img: 'horse2.png' },
    { id: 3, name: 'Žlutý (3)', img: 'horse3.png' },
    { id: 4, name: 'Červený (4)', img: 'horse4.png' },
    { id: 5, name: 'Fialový (5)', img: 'horse5.png' }
];

function Races() {
    const { fetchTokens } = useTokens();
    const [isRacing, setIsRacing] = useState(false);
    const [winner, setWinner] = useState(null);
    const [betHorse, setBetHorse] = useState(null);
    const [betAmount, setBetAmount] = useState('');
    const [raceData, setRaceData] = useState([]);

    const handleStartRace = async () => {
        if (!betHorse) {
            Swal.fire('Chyba', 'Vyber si koně na kterého sázíš.', 'warning');
            return;
        }

        if (!betAmount || betAmount <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        const userId = localStorage.getItem('fw_user');

        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        setIsRacing(true);

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/races.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    betHorse: betHorse,
                    betAmount: betAmount
                })
            });

            const data = await response.json();

            if (data.error) {
                setIsRacing(false);
                Swal.fire('Chyba', data.error, 'error');
                return;
            }

            setRaceData(data.horses);

            setTimeout(() => {
                setIsRacing(false);
                setWinner(data.winner);

                if (data.win) {
                    Swal.fire('Výhra!', `Vyhrál jsi ${data.payout.toLocaleString('cs-CZ')} tokenů! 🎉`, 'success');
                } else {
                    Swal.fire('Prohra', 'Bohužel jsi prohrál, zkus to znovu! 😢', 'error');
                }

                fetchTokens();
            }, 5000);
        } catch (error) {
            setIsRacing(false);
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-races">
            <h1>Dostihy 🐎</h1>

            {winner !== null && (
                <div className="winning-horse">
                    Výherce: <strong>{horses.find(horse => horse.id === winner)?.name}</strong>
                </div>
            )}

            <div className="race-track">
                {horses.map((horse, index) => (
                    <div key={horse.id} className="horse-track">
                        <img
                            src={`/images/${horse.img}`}
                            alt={horse.name}
                            className={`horse ${isRacing ? 'racing' : ''}`}
                            style={{
                                animationDuration: `${raceData[index] || 5}s`
                            }}
                        />
                    </div>
                ))}
            </div>

            <div className="bet-section">
                <select onChange={(e) => setBetHorse(Number(e.target.value))}>
                    <option value="">Vyber si koně</option>
                    {horses.map(horse => (
                        <option key={horse.id} value={horse.id}>{horse.name}</option>
                    ))}
                </select>

                <input
                    type="number"
                    min="2"
                    value={betAmount}
                    onChange={(e) => setBetAmount(e.target.value)}
                    placeholder="Zadej sázku"
                />

                <button className="btn btn-warning" onClick={handleStartRace} disabled={isRacing}>
                    {isRacing ? 'Závod probíhá...' : 'Start'}
                </button>
            </div>
        </div>
    );
}

export default Races;
